import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

/* 	Utility function, split an array into two
 *  @function partition
 *  @param {array} array  - A source array of values
 *  @param {function} isValid - Comparator function that returns true/fase
 * 	@returns {array} - returns two partitioned arrays
 */
var partition = function partition(array, isValid) {
  return array.reduce(function (_ref, elem) {
    var _ref2 = _slicedToArray(_ref, 2),
      pass = _ref2[0],
      fail = _ref2[1];
    return isValid(elem) ? [[].concat(_toConsumableArray(pass), [elem]), fail] : [pass, [].concat(_toConsumableArray(fail), [elem])];
  }, [[], []]);
};

/*  Utility function, Returns a date as a Unix timestamp
 *  @function getEpoch
 *  @param {string} dateValue  - A valid date: 12/31/2001
 *  @returns {number} - A unix timestamp for the input date
 */
var getEpoch = function getEpoch(dateValue) {
  return parseInt((new Date(dateValue).getTime() / 1000).toFixed(0));
};

export { getEpoch, partition };
